import React from 'react';

export default () => (
	<svg width="20" 
		height="12" 
		viewBox="0 0 20 12" 
		fill="none" 
		xmlns="http://www.w3.org/2000/svg"
	>
		<path 
			d="M5.87372 0C4.69897 0 3.70044 0.792951 3.37739 1.87959H0.704846C0.293686 1.87959 0 2.20264 0 2.6138C0 3.02496 0.323054 3.34802 0.734214 3.34802H3.40675C3.70044 4.43465 4.72834 5.22761 5.90308 5.22761C7.10719 5.22761 8.10573 4.43465 8.42878 3.34802H19.2658C19.6769 3.34802 20 3.02496 20 2.6138C20 2.20264 19.6769 1.87959 19.2658 1.87959H8.42878C8.07636 0.792951 7.07783 0 5.87372 0ZM5.90308 1.46843C6.51982 1.46843 7.04846 1.96769 7.04846 2.6138C7.04846 3.25991 6.51982 3.75918 5.90308 3.75918C5.28634 3.75918 4.75771 3.25991 4.75771 2.6138C4.75771 1.96769 5.28634 1.46843 5.90308 1.46843Z" 
			fill="#332F2F"
		/>
		<path
			d="M14.7137 5.87354C13.5389 5.87354 12.5404 6.66649 12.2173 7.75312H0.734214C0.293686 7.75312 0 8.07618 0 8.48734C0 8.8985 0.323054 9.22155 0.734214 9.22155H12.2173C12.511 10.3082 13.5389 11.1011 14.7137 11.1011C15.9178 11.1011 16.9163 10.3082 17.2394 9.22155H19.2658C19.6769 9.22155 20 8.8985 20 8.48734C20 8.07618 19.6769 7.75312 19.2658 7.75312H17.2394C16.9163 6.66649 15.9178 5.87354 14.7137 5.87354ZM14.743 7.34196C15.3598 7.34196 15.8884 7.84123 15.8884 8.48734C15.8884 9.13345 15.3598 9.63271 14.743 9.63271C14.1263 9.63271 13.5977 9.13345 13.5977 8.48734C13.5977 7.84123 14.0969 7.34196 14.743 7.34196Z" 
			fill="#332F2F"
		/>
	</svg>
)